<div class="form-group">
    {{ 'expense-rule.type-of-rule' | translate }}
    <ng-select
        [disabled]="true"
        [placeholder]="'expense-rule.type-of-rule' | translate"
        [(ngModel)]="selectedRuleType"
        appendTo="body"
        (change)="selectRuleType($event)"
    >
        <ng-option *ngFor="let ruleType of ruleTypes" [value]="ruleType.key">
            <span class="capitalize-word">{{ ruleType.display }}</span>
        </ng-option>
    </ng-select>
</div>
